import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import RemovedLeftSideUnitComponent from "../components/RemovedLeftSideUnitComponent";
import RemovedRightSideUnitComponent from "../components/RemovedRightSideUnitComponent";
import logEmptyFunctionWarning from "../functions/logEmptyFunctionWarning";
import { SIDE_UNIT_LEFT, SIDE_UNIT_RIGHT } from "../constants";
import { replaceProductPart } from "../functions/productUtils";
export class HandleSideUnitRemovalSystem extends SystemBase2 {
    constructor(productManager, coreServices) {
        super(RemovedLeftSideUnitComponent.id, RemovedRightSideUnitComponent.id);
        this.productManager = productManager;
        this.coreServices = coreServices;
        this.doingChangesOnComponent = [];
        this.id = "HandleSideUnitRemovalSystem";
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent", this.id);
    }
    onRemoveComponent(_entity, oldComponent) {
        replaceProductPart(_entity, SIDE_UNIT_LEFT, oldComponent.sideUnitRef, this.coreServices);
    }
    onAddComponent2(_entity, _newComponent) {
        super.onAddComponent2(_entity, _newComponent);
    }
    onUpdateComponent2(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent2", this.id);
    }
    onRemoveComponent2(_entity, oldComponent) {
        replaceProductPart(_entity, SIDE_UNIT_RIGHT, oldComponent.sideUnitRef, this.coreServices);
    }
}
